import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Menu } from '../../menu/menu.model';
import { MenuService } from '../../menu/menu.service';
import { MenuItem } from '../menuItem.model';
import { MenuitemsService } from '../menuitems.service';

@Component({
  selector: 'app-listmenuitems',
  templateUrl: './listmenuitems.component.html',
  styleUrls: ['./listmenuitems.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
  
})
export class ListmenuitemsComponent implements OnInit {

  //#region variables
  menus:Menu[] = [];
  menuItems: MenuItem[] = [];
  displayedColumns: string[] = ['id', 'name', 'link', 'icon', "edit", "delete"];
  dataSource!: MatTableDataSource<MenuItem>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  menuItem: MenuItem = {} as MenuItem;
  subCatgstatus: { id: number, name: string }[] = [];
  selectedMenu!:number;
  language!:number;
  //#endregion

  constructor(private service: MenuitemsService,
    private menuService:MenuService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage:LocalStorageService,
    private translate:TranslateService,
    private storage:SessionStorageService) { }

  ngOnInit() {
    this.language = this.localStorage.retrieve("lang"); 
    this.getMenu();
   
  }

  getMenu() {
    this.spinnerOverlay = true;
    this.menuService.getAll().subscribe(data => {
      this.menus = data
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getMenuItem() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedMenu).subscribe(data => {
      this.menuItems = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.menuItems);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/systemsettings/addmenuitem']);
  }

  edit(id:number) {
    this.router.navigate(['./master/systemsettings/editmenuitem/' + id]);
  }

  onDelete(id:number) {
    this.menuItem.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.menuItem.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"),'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMenuItem();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message:any, cssclass:any) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange(){
    this.getMenuItem();
  }

}
